import React from 'react'
import BasicButton from "../components/BasicButton";
import {useModal} from "../components/Modal";
import {openSelectReportsModal} from "../containers/modals/SelectReportsModal";

export default function ProsReportsButton(props) {
    const modalContext = useModal()
    return <BasicButton
        btnClass={"2nd"}
        icon={props.icon && "check-list"}
        label={props.label}
        btnType={"prompt"}
        size={props.size}
        tag={!props.isSearchMode && props.preSelectedReportIds.length < 1 ?
            <i className={"ui-icon ui-icon-xs ui-icon-minus ui-icon_color-light"}/>
            : null}
        tooltip={props.label ? null : ["Valitse " + (props.isSearchMode ? "haku" : "raportit")]}
        action={() => { openSelectReportsModal(modalContext, props)}}
        disabled={props.disabled}
    />
}